(function () {
  const SECTION_SELECTOR =
    '[data-section-type="section-carousel"][data-autoplay-grid="true"],' +
    '[data-section-type="collection-row"][data-autoplay-grid="true"],' +
    '[data-section-type="collection"][data-autoplay-grid="true"]';

  const CARD_SELECTOR =
    'product-grid-item-variant.is-slideshow[data-slideshow-style="cycle_images"],' +
    'product-grid-item-variant[data-slideshow-style="cycle_images"]';

  function toBool(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return value === true || value === 'true';
  }

  function toInt(value, fallback) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function activateTemplate(imageEl) {
    if (!imageEl) return;

    const template = imageEl.querySelector('template');
    if (!template) return;

    const content = template.content ? template.content.cloneNode(true) : null;
    if (!content) return;

    imageEl.innerHTML = '';
    imageEl.appendChild(content);
  }

  function getImages(card, maxImages) {
    const images = Array.from(card.querySelectorAll('product-grid-item-image[data-grid-image]'));

    const usable = images.filter(function (img) {
      return img && !img.hasAttribute('hidden');
    });

    if (maxImages && maxImages > 0) {
      return usable.slice(0, maxImages);
    }

    return usable;
  }

  function setActive(card, images, index) {
    if (!images.length) return;

    const normalizedIndex = index % images.length;

    images.forEach(function (img, i) {
      if (i === normalizedIndex) {
        activateTemplate(img);
        img.classList.add('is-active');
        img.setAttribute('data-grid-current-image', 'true');
        img.removeAttribute('aria-hidden');
      } else {
        img.classList.remove('is-active');
        img.removeAttribute('data-grid-current-image');
        img.setAttribute('aria-hidden', 'true');
      }
    });

    const dots = Array.from(card.querySelectorAll('[data-grid-pagination] [data-grid-page]'));
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === normalizedIndex);
    });
  }

  function preloadNext(images, index) {
    if (!images.length) return;

    const next = images[(index + 1) % images.length];
    if (!next) return;

    activateTemplate(next);

    const img = next.querySelector('img');
    if (!img) return;

    try {
      if (img.dataset && img.dataset.src) img.src = img.dataset.src;
      if (img.dataset && img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.loading = 'eager';
    } catch (e) {}
  }

  function initCard(card, interval, maxImages, pauseOnHover) {
    if (card.__autoCycleGridInitialized) return;
    card.__autoCycleGridInitialized = true;

    const images = getImages(card, maxImages);
    if (images.length <= 1) return;

    let index = images.findIndex(function (img) {
      return img.classList.contains('is-active') || img.hasAttribute('data-grid-current-image');
    });

    if (index < 0) index = 0;

    setActive(card, images, index);
    preloadNext(images, index);

    let paused = false;

    if (pauseOnHover) {
      card.addEventListener('mouseenter', function () {
        paused = true;
      });

      card.addEventListener('mouseleave', function () {
        paused = false;
      });

      card.addEventListener('touchstart', function () {
        paused = true;
        window.setTimeout(function () {
          paused = false;
        }, 2500);
      }, { passive: true });
    }

    card.__autoCycleGridTimer = window.setInterval(function () {
      if (paused) return;
      if (!document.body.contains(card)) {
        window.clearInterval(card.__autoCycleGridTimer);
        return;
      }

      index = (index + 1) % images.length;
      setActive(card, images, index);
      preloadNext(images, index);
    }, interval);
  }

  function initSection(section) {
    if (!section || section.__autoCycleGridSectionInitialized) return;
    section.__autoCycleGridSectionInitialized = true;

    const desktopOnly = toBool(section.dataset.autoplayDesktopOnly, false);
    if (desktopOnly && window.matchMedia('(max-width: 767px)').matches) return;

    const interval = Math.max(toInt(section.dataset.autoplayInterval, 3000), 800);
    const pauseOnHover = toBool(section.dataset.autoplayPause, true);
    const maxImages = toInt(section.dataset.autoplayMax, 0);

    const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));

    cards.forEach(function (card) {
      initCard(card, interval, maxImages, pauseOnHover);
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  window.addEventListener('load', initAll);

  const observer = new MutationObserver(function () {
    initAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();